// src/api/cashRegister.api.ts
import { get, post } from './client';

export const cashRegisterApi = {
  // Open a new cash register
  openRegister: (data: {
    cashierId: string;
    openingBalance: number;
    notes?: string;
  }) => post('/cash-register/open', data),

  // Get the currently active register
  getActiveRegister: (cashierId?: string) =>
    get('/cash-register/active', { params: cashierId ? { cashierId } : {} }),

  // Close the active register
  closeRegister: (data: {
    registerId: string;
    actualBalance: number;
    notes?: string;
  }) => post('/cash-register/close', data),

  // Get register history
  getRegisterHistory: (params?: {
    page?: number;
    limit?: number;
    cashierId?: string;
    startDate?: string;
    endDate?: string;
  }) => get('/cash-register/history', { params }),

  // Get register by ID
  getRegisterById: (id: string) => get(`/cash-register/${id}`),

  // Get available cashiers
  getCashierList: () => get('/cash-register/cashiers'),

  // Cashier self-check: do I have an active register?
  getMyRegisterStatus: () => get('/cash-register/my-status'),
};
